<template>
  <div>
    <div class="all-chart" ref="wrapper"></div>
  </div>
</template>


<script>
// グラフを重ねて描きたい場合はここらへん
// https://plot.ly/python/radar-chart/
import Plotly from "plotly.js-dist";
import { mean, standardDeviation, max } from "simple-statistics";
import { round } from "@/utils/statics.js";

export default {
  props: {
    values: {
      required: true,
    },
    ops: {
      required: true,
    },
    categories: {
      required: false,
    },
  },
  data() {
    return {
      numOfOptions: this.ops.length,
      items: [],
    };
  },
  mounted() {
    const items = this.getItems();
    const selfData = [];
    const coWorkerData = [];
    const categories = [];
    items.forEach((item) => {
      selfData.push(item.selfs);
      coWorkerData.push(item.meanScore);
      categories.push(item.category);
    });
    // Format to Plotly's radar chart data format.
    // Plotly's radar chart data format is first and last values ​​must be the same.
    selfData.push(selfData[0]);
    coWorkerData.push(coWorkerData[0]);
    categories.push(categories[0]);
    console.log(categories);
    const data = [
      {
        type: "scatterpolar",
        r: selfData,
        theta: categories,
        line: {
          color: "rgb(255, 2, 2)",
          width: 2,
        },
      },
      {
        type: "scatterpolar",
        r: coWorkerData,
        theta: categories,
        line: {
          color: "rgb(30, 0, 255)",
          width: 2,
        },
      },
    ];

    const layout = {
      autosize: false,
        width: 300,
      height: 180,
      margin: {
        l: 40,
        r: 40,
        b: 30,
        t: 30,
        pad: 4,
      },
      polar: {
        radialaxis: {
          visible: false,
          range: [1, 6],
        },
      },
      showlegend: false,
    };
    // var layout = {
    //   // title: '評価者平均と本人採点',
    //   showlegend: false,
    //   font: {
    //     family: "Raleway, sans-serif"
    //   },
    //   yaxis: {
    //     fixedrange: true
    //   },
    //   xaxis: {
    //     fixedrange: true,
    //     ...(this.forPrint
    //       ? {
    //           tickangle: 30,
    //           tickvals: this.items.map(item => item.id),
    //           ticktext: this.items.map(item => item.question),
    //           tickfont: { size: 9 }
    //         }
    //       : {})
    //   },
    //   autosize: false,
    //   ...(this.forPrint
    //     ? {
    //         width: 1500,
    //         height: 600,
    //         margin: {
    //           b: 250,
    //           r: 270
    //         }
    //       }
    //     : {
    //         width: 1000,
    //         height: 500
    //       })
    // };
    console.log(data);
    Plotly.plot(this.$refs.wrapper, data, layout, {
      displayModeBar: false, // 右上のツールバーを非表示
      staticPlot: false, // マウスで拡大できないように
    }).then((el) => {
      this.$emit("plot-done", el);
    });
  },
  methods: {
    getItems() {
      console.log(this.categories);
      let categories = [...this.categories];
      categories.push(categories.shift());
      categories.push(categories.shift());

      categories = categories.reverse();

      return categories.map((k) => {
        const v = this.values[k];
        const avg = round(mean(v.score), 2);
        const selfsAvg = round(mean(v.selfs), 2);
        return {
          category: v.category,
          selfs: selfsAvg,
          meanScore: avg,
        };
      });
    },
  },
  beforeDestroy() {
    Plotly.purge(this.$refs.wrapper);
  },
};

function range(n) {
  const a = [];
  for (let i = 0; i < n; ++i) {
    a[i] = i;
  }
  return a;
}
</script>

